import { render, staticRenderFns } from "./DemographicAggregate.vue?vue&type=template&id=d1e98b40&"
import script from "./DemographicAggregate.vue?vue&type=script&lang=js&"
export * from "./DemographicAggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports